import React, { useState } from "react";

import { ChatHeader } from "./components/ChatHeader";
import { ChatHistoryPanel } from "./components/ChatHistoryPanel";
import { ChatWindow } from "./components/ChatWindow";
import { useWebChat } from "./hooks/useWebChat";

export function BluPayChat({ embedded = false }) {
  const chat = useWebChat();
  const [showHistory, setShowHistory] = useState(false);

  async function open(id) {
    await chat.openConversation(id);
    setShowHistory(false);
  }

  function startNew() {
    chat.startNewConversation();
    setShowHistory(false);
  }

  return (
    <div
      className={
        embedded
          ? "flex h-full min-h-0 flex-col bg-[#EFEAE2]"
          : "mx-auto flex w-full max-w-5xl flex-col px-4 py-6 md:px-6"
      }
    >
      <ChatHeader embedded={embedded} onShowHistory={() => setShowHistory(true)} />

      <div className={embedded ? "min-h-0 flex-1" : "mt-3"}>
        {showHistory ? (
          <ChatHistoryPanel
            conversations={chat.conversations}
            activeId={chat.conversationId}
            isLoading={chat.isLoadingConversations}
            error={chat.conversationsError}
            onOpen={open}
            onNew={startNew}
            onRename={chat.renameConversation}
            onArchive={chat.archiveConversation}
            onClose={() => setShowHistory(false)}
          />
        ) : (
          <ChatWindow
            messages={chat.messages}
            quickReplies={chat.quickReplies}
            sendMessage={chat.sendMessage}
            bottomRef={chat.bottomRef}
            activeCard={chat.activeCard}
            context={chat.context}
            createRecipient={chat.createRecipient}
            cancelRecipientCreation={chat.cancelRecipientCreation}
            isCreatingRecipient={chat.isCreatingRecipient}
            confirmWithPin={chat.confirmWithPin}
            isConfirmingTransfer={chat.isConfirmingTransfer}
            isPreparingTransfer={chat.isPreparingTransfer}
            fundingInstructions={chat.fundingInstructions}
            isLoadingFundingInstructions={chat.isLoadingFundingInstructions}
            fundingInstructionsNotReady={chat.fundingInstructionsNotReady}
            fundingInstructionsError={chat.fundingInstructionsError}
            transferDetail={chat.transferDetail}
            activeStep={chat.activeStep}
            isPending={chat.isPending}
            onRetry={chat.retryMessage}
            historyHasMore={chat.historyHasMore}
            onLoadEarlier={chat.loadEarlier}
            isLoadingEarlier={chat.isLoadingEarlier}
            composerPlaceholder={chat.composerPlaceholder}
            embedded={embedded}
          />
        )}
      </div>
    </div>
  );
}
